import { render, staticRenderFns } from "./AutoBidderFailedLogs.vue?vue&type=template&id=5b5a7ff8&"
import script from "./AutoBidderFailedLogs.vue?vue&type=script&lang=js&"
export * from "./AutoBidderFailedLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports